export const PhotoTag = () => (
    <span
        data-testid="photo-placeholder-tag"
        className="absolute bottom-3 left-3 z-10 rounded-full bg-forest-night/60 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-bone/90 backdrop-blur-sm"
    >
        Stock photo — your photo here
    </span>
);
